import { useContext, useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router";

import { IColumn, ITableRowData } from "../../../manager/components/data-table/data-table";
import EditableDataTable from "../../../manager/components/editable-data-table/editable-data-table";
import Page from "../../../manager/components/page/page";
import AuthContext from "../../../shared/context/auth-context";
import useHttp from "../../../shared/hooks/use-http";
import { useHttpGet } from "../../../shared/hooks/use-httpNonTable";
import { getData, postSingle } from "../../../shared/utils/api";
import { createUUID } from "../../../shared/utils/utils";
import { enumerationUrl } from "../../constants/backend-constants";

const columns: IColumn[] = [
  {
    key: "value",
    displayName: "Value",
    dataType: {
      type: "text",
    }
  }
];

const ListPage = () => {
  const authCtx = useContext(AuthContext);
  const params = useParams();
  const navigate = useNavigate();
  
  const [data, setData] = useState<{id: string, name: string, options: ITableRowData[]}>({
    id: "",
    name: "",
    options: [],
  });

  const { sendRequest: postData, status: postDataStatus, data: postDataResult, error: postDataError } = useHttp(postSingle, true, authCtx.token, "enumeration", "platform");
  
  const { sendRequest: getListData, status: getListDataStatus, data: getListDataResult, error: getListDataError } = useHttpGet(getData, true, authCtx.token, "enumeration", "platform");
  
  useEffect(() => {
    if (params.id) {
      getListData(`${enumerationUrl}/${params.id}`);
    } else {
      setData({
        id: createUUID(),
        name: "",
        options: [],
      });
    }
  }, []);

  useEffect(() => {
    if (getListDataStatus === "completed" && !getListDataError && getListDataResult) {
      setData({
        id: getListDataResult.id,
        name: getListDataResult.name,
        options: getListDataResult.options,
      });
    }
  }, [getListDataResult, getListDataStatus, getListDataError]);

  useEffect(() => {
    if (postDataStatus === "completed" && !postDataError && postDataResult) {
      navigate("/lists");
    }
  }, [postDataResult, postDataStatus, postDataError]);

  const handleSaveClicked = (listData: ITableRowData[]) => {
    postData(`${enumerationUrl}/${data.id}`, {
      id: data.id,
      name: data.name,
      options: listData
    });
  };

  const handleTitleEdited = (newTitle: string) => {
    setData({...data, name: newTitle});
  };

  return (
    <Page title={{text: data.name, placeholder: "List name", onTitleEdited: handleTitleEdited}} >
      <div className="list-page">
        <EditableDataTable 
          defaultSortCol="value"
          columns={columns} 
          data={data.options}
          onSaveClicked={handleSaveClicked}
        />
      </div>
    </Page>
  );
};

export default ListPage;
